
















































































































import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";

export default Vue.extend({
    props: {
        filters: {},
        iconColor: String,
        iconWidth: Number,
        iconLarge: Boolean,
        iconPadding: Number,
        showHour: Boolean,
        showPrependIcon: { default: true },
    },
    computed: {
        ...mapGetters(["userDateFormat", "userTimeFormat"]),
        pickerStartDateFormatted() {
            if (this.pickerStartDate == null || this.pickerStartDate == undefined) return this.pickerStartDate;
            return moment(this.pickerStartDate).format(this.userDateFormat);
        },
        pickerEndDateFormatted() {
            if (this.pickerEndDate == null || this.pickerEndDate == undefined) return this.pickerEndDate;
            return moment(this.pickerEndDate).format(this.userDateFormat);
        },
        pickerStartTimeFormatted() {
            if (this.pickerStartTime == null || this.pickerStartTime == undefined) return this.pickerStartTime;
            return moment(this.pickerStartTime, "HH:mm").format(this.userTimeFormat.timeFormat);
        },
        pickerEndTimeFormatted() {
            if (this.pickerEndTime == null || this.pickerEndTime == undefined) return this.pickerEndTime;
            return moment(this.pickerEndTime, "HH:mm").format(this.userTimeFormat.timeFormat);
        },
        pickerStartDate: {
            get() {
                return moment(this.filters.startDate).format("YYYY-MM-DD");
            },
            set(newValue: string) {
                let receivedNewDate = moment(newValue);

                let newDate = moment(this.filters.startDate);
                newDate.year(receivedNewDate.year());
                newDate.month(receivedNewDate.month());
                newDate.date(receivedNewDate.date());

                this.filters.startDate = newDate.toDate();
                this.$emit("input", this.filters);
            },
        },

        pickerStartTime: {
            get() {
                return moment(this.filters.startDate).format("HH:mm");
            },
            set(newValue: string) {
                let newStartDate = moment(this.filters.startDate);
                newStartDate.hours(Number(newValue.split(":")[0]));
                newStartDate.minutes(Number(newValue.split(":")[1]));

                this.filters.startDate = newStartDate.toDate();
            },
        },

        pickerEndDate: {
            get() {
                return moment(this.filters.endDate).format("YYYY-MM-DD");
            },
            set(newValue: string) {
                let receivedNewDate = moment(newValue);

                let newDate = moment(this.filters.endDate);
                newDate.year(receivedNewDate.year());
                newDate.month(receivedNewDate.month());
                newDate.date(receivedNewDate.date());

                this.filters.endDate = newDate.toDate();

                this.$emit("input", this.filters);
            },
        },

        pickerEndTime: {
            get() {
                return moment(this.filters.endDate).format("HH:mm");
            },
            set(newValue: string) {
                let newDate = moment(this.filters.endDate);
                newDate.hours(Number(newValue.split(":")[0]));
                newDate.minutes(Number(newValue.split(":")[1]));

                this.filters.endDate = newDate.toDate();

                this.$emit("input", this.filters);
            },
        },
    },
});
